import { calculateTextExprValue, setAdvancedConfigToProps, } from '@/common/util/util';
import { CnEmployeeSelect, componentMap as formComponentMap, } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position/display-position';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.filter,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'EmployeeSelect',
    component: CnEmployeeSelect,
    formComponent: formComponentMap.CnEmployeeSelect,
};
CnEmployeeSelect.filterBeforeHandler = (props, config) => {
    const newProps = {
        ...props,
    };
    const { serviceType } = props || {};
    const { recordDataSource, state } = config || {};
    if (newProps.dataSource === undefined) {
        delete newProps.dataSource;
    }
    newProps.serviceType = calculateTextExprValue(serviceType, {
        recordDataSource,
        state,
    });
    if (newProps.serviceType !== 'ali') {
        newProps.serviceType = 'cainiao';
    }
    setAdvancedConfigToProps(newProps);
    return newProps;
};
CnEmployeeSelect.formBeforeHandler = CnEmployeeSelect.filterBeforeHandler;
